import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ActiveTenantRole, TenantAuthorizationService } from './tenant-authorization.service';

/**
 * HTTP Interceptor that injects the active tenant role and UI language into API requests.
 */
@Injectable()
export class TokenInjector implements HttpInterceptor {
    private readonly tenantAuthorizationService = inject(TenantAuthorizationService);
    private readonly translate = inject(TranslateService);

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const endpointUrl = this.removeProtocol(environment.endpoint);

        if (request.url.includes(endpointUrl)) {
            const setHeaders: Record<string, string> = {
                'Accept-Language': this.currentLanguage()
            };
            const tenantRole = this.getTenantRoleFromStorage();
            if (tenantRole) {
                setHeaders['x-sal-tenant'] = tenantRole as string;
            }
            request = request.clone({ setHeaders });
        }

        return next.handle(request);
    }

    private getTenantRoleFromStorage(): ActiveTenantRole | null {
        return (
            this.tenantAuthorizationService.activeTenantRole() ?? this.tenantAuthorizationService.readActiveTenantRole()
        );
    }

    private currentLanguage(): string {
        return (this.translate.getCurrentLang() || this.translate.getFallbackLang() || 'en').toLowerCase();
    }

    private removeProtocol(str: string): string {
        return str.replace(/^https?:\/\//, '');
    }
}
